module.exports = __webpack_public_path__ + "static/img/logo.285704e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/MainHeader/static/assets/images/logo.png
// module id = 243
// module chunks = 0